(() => {
  function initialise(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.querySelectorAll('[data-category]').forEach(section => {
      const select = section.querySelector('[data-competitor]');
      const differences = section.querySelector('[data-differences]');
      const allButton = section.querySelector('[data-show-all]');
      const table = section.querySelector('table');
      const status = section.querySelector('[data-compare-status]');
      let showAll = false;
      const update = () => {
        const ids = [section.dataset.own, select.value];
        section.querySelectorAll('[data-product]').forEach(cell => {
          cell.hidden = !showAll && !ids.includes(cell.dataset.product);
        });
        let hiddenRows = 0;
        table.querySelectorAll('tbody tr').forEach(row => {
          const values = [...row.querySelectorAll('[data-product]')].filter(cell => !cell.hidden).map(cell => cell.textContent.trim());
          const same = values.length > 1 && values.every(value => value === values[0]);
          row.hidden = differences.checked && same;
          if (row.hidden) hiddenRows++;
        });
        table.dataset.pair = String(!showAll);
        table.dataset.all = String(showAll);
        allButton.setAttribute('aria-pressed', String(showAll));
        allButton.textContent = showAll ? 'Return to two brands' : 'Show all brands';
        select.disabled = showAll;
        status.textContent = (showAll ? 'Showing all researched brands in this category.' : `Comparing GOPRYME with ${select.selectedOptions[0].textContent.split(' — ')[0]}.`) + (differences.checked ? ` ${hiddenRows} identical ${hiddenRows === 1 ? 'row hidden' : 'rows hidden'}.` : '');
      };
      select.addEventListener('change', update);
      differences.addEventListener('change', update);
      allButton.addEventListener('click', () => { showAll = !showAll; update(); });
      section.querySelector('[data-enhanced]').hidden = false;
      update();
    });
  }
  document.querySelectorAll('[data-brand-comparison]').forEach(initialise);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-brand-comparison]').forEach(initialise));
})();
